import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';

const LogoutConfirmation = ({ isOpen, onClose, onConfirm, message }) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    onClose(); 
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle> 
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" align="center">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button
          
          onClick={onClose}
          style={{ marginRight: '10px', color: 'red' }}
        >
          No
        </Button>
        <Button
          
          onClick={onConfirm}
          style={{ backgroundColor: 'red', color: 'white' }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmation;
